(function ($) {
    'use strict';
    $(document).ready(function () {
        $(document).on('submit', 'form[action*="yith/waitlist-register"]', function (e) {
            e.preventDefault();

            var $form        = $(this);
            var $submitBtn   = $form.find('.yith-wcwtl-submit1, input[type="submit"]');
            var $emailField  = $form.find('#yith-wcwtl-email');
            var $policyCheck = $form.find('#yith-wcwtl-policy-check');
            var email        = $emailField.val().trim();

            $('.yith-wcwtl-ajax-message').remove();
            $emailField.removeClass('yith-wcwtl-error-field');
            $policyCheck.removeClass('yith-wcwtl-error-field');

            var hasError = false;

            if (!email || !isValidEmail(email)) {
                showMessage($form, 'Por favor, informe um e-mail válido.', 'error');
                $emailField.addClass('yith-wcwtl-error-field').focus();
                hasError = true;
            }

            if (!$policyCheck.is(':checked')) {
                if (!hasError) {
                    showMessage($form, 'Você precisa aceitar a política de privacidade para continuar.', 'error');
                }
                $policyCheck.closest('label').css({
                    outline: '2px solid #f44336',
                    outlineOffset: '2px',
                    borderRadius: '2px'
                });
                hasError = true;
            }

            if (hasError) return;
            $submitBtn.prop('disabled', true).addClass('yith-wcwtl-loading');
            $form.addClass('yith-wcwtl-form--submitting');

            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: {
                    'yith-wcwtl-email': email,
                },
                dataType: 'json',
                success: function (response) {
                    if (response === true || (response && response.success === true)) {
                        showMessage($form, 'Cadastro realizado com sucesso! Você será notificado assim que o produto estiver disponível.', 'success');
                        $form[0].reset();
                    } else {
                        var errorMsg = (response && response.message)
                            ? response.message
                            : 'Não foi possível realizar o cadastro. Verifique seu e-mail e tente novamente.';
                        showMessage($form, errorMsg, 'error');
                    }
                },
                error: function (jqXHR) {
                    var fallbackMsg = 'Erro de conexão. Tente novamente mais tarde.';

                    if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                        fallbackMsg = jqXHR.responseJSON.message;
                    }

                    showMessage($form, fallbackMsg, 'error');
                },
                complete: function () {
                    $submitBtn.prop('disabled', false).removeClass('yith-wcwtl-loading');
                    $form.removeClass('yith-wcwtl-form--submitting');
                },
            });
        });

        $(document).on('change', '#yith-wcwtl-policy-check', function () {
            if ($(this).is(':checked')) {
                $(this).closest('label').css({
                    outline: '',
                    outlineOffset: '',
                    borderRadius: ''
                });
            }
        });

        function isValidEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        }

        function showMessage($form, message, type) {
            var $msg = $('<div>')
                .addClass('yith-wcwtl-ajax-message yith-wcwtl-message--' + type)
                .html('<span class="yith-wcwtl-message__icon"></span><span class="yith-wcwtl-message__text">' + message + '</span>');

            $form.after($msg);

            setTimeout(function () {
                $msg.fadeOut(400, function () {
                    $(this).remove();
                });
            }, 8000);
        }
    });
})(jQuery);